import { testimonials } from '@/mocks/superbuy';

export default function TestimonialSection() {
  return (
    <section className="py-24 md:py-28 bg-secondary-50/40">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <span className="inline-block text-xs tracking-[0.25em] uppercase text-secondary-600 font-medium mb-4 bg-secondary-100/80 px-3 py-1 rounded-full">
            Testimonials
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            Real Reviews.
            <br />
            Real Finds.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {[0, 1, 2].map((colIdx) => (
            <div key={colIdx} className={`flex flex-col gap-5 md:gap-6 ${colIdx === 1 ? 'md:mt-8' : ''}`}>
              {testimonials.filter((_, i) => i % 3 === colIdx).map((t) => (
                <div
                  key={t.username}
                  className="bg-background-50 rounded-2xl p-5 md:p-6"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-10 h-10 rounded-full ${t.avatarBg} flex items-center justify-center flex-shrink-0`}>
                      <span className="text-sm font-bold text-foreground-700">
                        {t.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.username}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    &ldquo;{t.text}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}